module.exports = __webpack_public_path__ + "2241453a50cf166097f425509adffcf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-5.svg
// module id = 165
// module chunks = 0